import { gql } from 'graphql-request';

const addAddressMutation = gql`
  mutation (
    $subdomain: String
    $areaId: ID
    $cityName: String
    $areaName: String
    $street: String!
    $unitType: String!
    $unitNo: String!
    $block: String
    $building: String
    $floor: String
    $avenue: String
    $notes: String
    $lng: String
    $lat: String
    $phoneNumber: String
    $title: String
    $dzmsVerified: Boolean!
  ) {
    addAddress(
      subdomain: $subdomain
      areaId: $areaId
      street: $street
      unitType: $unitType
      unitNo: $unitNo
      areaName: $areaName
      cityName: $cityName
      block: $block
      building: $building
      floor: $floor
      avenue: $avenue
      notes: $notes
      lng: $lng
      lat: $lat
      phoneNumber: $phoneNumber
      title: $title
      dzmsVerified: $dzmsVerified
    ) {
      id
      userId
      title
      street
      block
      building
      unitType
      unitNo
      covered
      lat
      lng
      dzmsVerified
      area {
        id
        titleAr
        titleEn
      }
    }
  }
`;

export default addAddressMutation;
